import React from "react";
import { FaGoogle } from "react-icons/fa";

import { Button } from "../../../components";
import useOAuth, { OnAuth, OnError } from "../../hooks/useOAuth";

interface GoogleAuthButtonProps {
  label: string;
  onAuth: OnAuth;
  onError: OnError;
  feature: "auth" | "calendar";
}

const GoogleAuthButton: React.FC<GoogleAuthButtonProps> = ({
  label,
  onAuth,
  onError,
  feature = "auth",
}) => {
  const { onClick, isLoading } = useOAuth({
    provider: "google",
    onAuth,
    onError,
    feature,
  });

  return (
    <Button
      leftIcon={<FaGoogle />}
      width="100%"
      onClick={onClick}
      isLoading={isLoading}
      data-testid={isLoading ? null : "google-auth-button"}
    >
      {label}
    </Button>
  );
};

export default GoogleAuthButton;
